import { FiscalYear } from 'app/internal/shared/models/fiscal-year';
import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Observable } from 'rxjs';
import { Property } from '../../../property/shared/models';
import { getSelectedProperty, getSelectedFiscalYear } from '../../../property/property-store/property.selectors';
import { UserProfile } from 'app/internal/user/models';
import { getUserProfile } from 'app/internal/user/redux/user.selectors';

@Component({
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: false
})

export class AdminMainComponent {

  property$: Observable<Property>;
  selectedFiscalYear$: Observable<FiscalYear>;
  userProfile$: Observable<UserProfile>;

  constructor(private store: Store<AppState>) {
    this.property$ = this.store.pipe(select(getSelectedProperty));
    this.selectedFiscalYear$ = this.store.pipe(select(getSelectedFiscalYear));
    this.userProfile$ = this.store.pipe(select(getUserProfile));
  }
}
